import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const routes = [
  {
    path: "/",
    name: "Chat",
    component: () => import("@/views/ChatView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/error/no-session",
    name: "NoSession",
    component: () => import("@/views/NoSessionView.vue"),
  },
  {
    path: "/error/no-access",
    name: "NoAccess",
    component: () => import("@/views/NoAccessView.vue"),
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, _from, next) => {
  const auth = useAuthStore();
  if (to.meta.requiresAuth) {
    if (!auth.initialised) {
      const ok = await auth.init();
      if (!ok) {
        if (to.name === "NoSession") return next();
        return next({ name: "NoSession" });
      }
    }
    if (auth.accessibleAccounts.length === 0 && to.name !== "NoAccess") {
      return next({ name: "NoAccess" });
    }
  }
  next();
});
